import type { SWRConfiguration } from 'swr'
import useSWR from 'swr'

import { getItem } from '../api/itemApi'
import { Item } from '../types'

export default function useItem(id: Item['id'], options?: SWRConfiguration) {
  return useSWR<Item, Error>(['item', id], () => getItem(id), options)
}
